import dictionnary from '../data/dictionnary.json';

class DictionnaryManager {
  constructor(mainKey, lang = 'en') {
    this.mainKey = mainKey;
    this.dict = dictionnary.find((obj) => obj._key === lang);
    if (!this.dict) {
      this.dict = dictionnary.find((obj) => obj._key === 'en');
    }
  }

  get(key) {
    const result = this.dict[key];
    return result;
  }
}
export default DictionnaryManager;
